import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth/AuthProvider';

function AuthSplash() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}
    >
      <p style={{ letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--color-gold-champagne)', fontSize: 12 }}>
        Legacy Architect
      </p>
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'hydrating') return <AuthSplash />;
  if (status === 'anon') return <Navigate to="/signin" replace state={{ from: location }} />;
  return <>{children}</>;
}
